var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 11,
    height: 11,
    fill: "url(#pattern0_641_459)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_641_459",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_641_459",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_641_459",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAA8RJREFUWIWtls9vG1UQxz+z619VbVPya02w04UEu6hKEZgKVC4cuCFxiBLVFCEuReJf4V8ALhGiiRQ1B64gDlyiggyiVRo7aVQr3dpJk4aqTkLieP042BuctUPttb+n3ZnxfOY9z3s7wmlpRiI5oyGfKrgKDAM7CH9KjbmSlZ8DbDxqbGzy5Y3hwB7Z7LFjE+chZl4ysdUC8O7/5LhrK21621pZ6xY+OpocUrr8rFDrmyORjFOENMGXgFgHuXY1m2vFYj7fPZy36ha16BShAVpj5Z3AAQZquroNH/q8wQFkKvakPE867deMRHKG9tt+jJAHjlpdctmIl77wBm9kQMbjW4cRTZAbrU71k2ar0c2N/KWQfhQDfmyJ0fjMO5y/xFYfWdbyrkbr6itic6NYXN0BKBQKzypB+3OE8qkoxdVe4E5+DRhyxRQcp6PdBw+eo8i54sKmaYZ6gTsF7LriLpqmeaHZYBhXzgNJV9x+oVA47AVeL0BJ1hUbPLSDswMTE1EHLoHKd8BLrpSnfucFDuAT1LyCj132TwIV3YolUjk4SrbCQVBzvcIbfvRYIvUHcKVdwBlaHYz6JpeXlyu9wKHeA7Zekxlae6G9hLJSMt0PuFMAjx/nVjWba6CWX4BfVTX5YMvK3esHHEB3Hsrlp0/3nk9+cz66tyEQRhgBAsAByBLw9WDU9+XD9ZVSv+CN+LNlmmaoH0fNcwFueYHH4/FzlmX903MBncJN0wwdVkM3laiMwDvAOeAA4Y6qqVtbRmS27UDSD/joxYm3azX9NvDa2dnkvmarKWeeeGEBXcJ/BcIdrGnXVtr729bKmtYPuGmaocbKO4EDDPiktgDo+lkR3TRcKBz7CqFlrlDwTOAuEAGCLncsEh1abbsD3Xa7EpVpgQs/+NX+6Oaj/HuVoJ2gzVCjUJmWHvBy1GKJ1AH1bj9ZuW6HXy0WsweOzTTNC4d2cIv65eaodGoHvJ7zZngjdq0ZDvXJCii40g6cFOD1hmtcMvsuc8qZJxwZxvgIruOpYEfrBd6k313v0cCR/r0zWRnG+Ij4fXOA35X9N4nHLw/YUv2ll7vdiCdvisi3bVwVhIcoXm+FgyiZ1iwjVFaoda9wgC0jMgtyv40rgCLVDo6wVLJyixrZ7PHmSCQDatELHIBs9liz1RSdDjVQ0qrV64D67xim0/7Yk/K8IOPdflIdDcfffMMntYV2f+eJhCWtWr1eLK4/qr82K532j21Xwhsb9/7uFt4k/ZV4KqNQGUTSwKCCbUHdEaXdKlm5RUA5wf8CwSpR7wl5fXgAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.f7a602acf16283f569671744241fca9e.svg";
export { ForwardRef as ReactComponent };